export type MentorContacts = {
  main: string;
  reserve: string;
};
export enum MentorStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export interface Mentor {
  _id: string;
  username: string;
  contacts: MentorContacts;
  isActive: boolean;
  totalIncome: number;
  userId: {
    _id: string;
    username: string;
  };
  activeStudentsCount: number;
  graduatedStudentsCount: number;
}
